// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Logs.css - Styled Similar to File Path Trigger */

/* Container */
.logs-container {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 10px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

h2 {
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

/* Log Entry Styling */
.log-entry {
  width: 100%;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.log-email {
  background-color: #f8f9fa;
  padding: 12px 15px;
  cursor: pointer;
  font-weight: 500;
  color: #2c3e50;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  font-weight: 500;
}

.log-email:hover {
  background-color: #e9ecef;
}

/* Year Section */
.log-years {
  padding: 10px;
}

.log-year {
  margin-bottom: 10px;
}

.log-year-header {
  background-color: #e9ecef;
  padding: 8px 15px;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.log-year-header:hover {
  background-color: #dee2e6;
}

/* Month Section */
.log-months {
  padding-left: 20px;
  margin-top: 5px;
}

.log-month {
  margin-bottom: 8px;
}

.log-month-header {
  background-color: #f1f3f5;
  padding: 6px 15px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.log-month-header:hover {
  background-color: #e9ecef;
}

/* Log List */
.log-list {
  list-style: none;
  padding-left: 25px;
  margin: 5px 0;
}

.log-date-group {
  margin: 10px 0;
}

.log-date-header {
  font-weight: 500;
  color: #495057;
  padding: 5px 0;
  background-color: #f8f9fa;
  padding-left: 10px;
  border-radius: 4px;
}

.log-items {
  list-style: none;
  padding-left: 15px;
  margin: 5px 0;
}

.log-item {
  padding: 5px 10px;
  color: #666;
  font-size: 0.9em;
  border-left: 2px solid #dee2e6;
  margin: 5px 0;
}

.log-item:hover {
  background-color: #f8f9fa;
  border-left-color: #6c757d;
}

/* Expand/Collapse Icons */
span {
  font-size: 12px;
  color: #6c757d;
}

/* Responsive Design */
@media (max-width: 768px) {
  .logs-container {
    padding: 10px;
  }
  
  .log-months {
    padding-left: 10px;
  }
  
  .log-list {
    padding-left: 15px;
  }
  
  .log-item {
    font-size: 0.85em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Logs.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Logs.css - Styled Similar to File Path Trigger */\n\n/* Container */\n.logs-container {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  background-color: #f5f5f5;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\nh2 {\n  color: #333;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n/* Log Entry Styling */\n.log-entry {\n  width: 100%;\n  margin-bottom: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.log-email {\n  background-color: #f8f9fa;\n  padding: 12px 15px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #2c3e50;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #ddd;\n  font-weight: 500;\n}\n\n.log-email:hover {\n  background-color: #e9ecef;\n}\n\n/* Year Section */\n.log-years {\n  padding: 10px;\n}\n\n.log-year {\n  margin-bottom: 10px;\n}\n\n.log-year-header {\n  background-color: #e9ecef;\n  padding: 8px 15px;\n  cursor: pointer;\n  border-radius: 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.log-year-header:hover {\n  background-color: #dee2e6;\n}\n\n/* Month Section */\n.log-months {\n  padding-left: 20px;\n  margin-top: 5px;\n}\n\n.log-month {\n  margin-bottom: 8px;\n}\n\n.log-month-header {\n  background-color: #f1f3f5;\n  padding: 6px 15px;\n  cursor: pointer;\n  border-radius: 4px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.log-month-header:hover {\n  background-color: #e9ecef;\n}\n\n/* Log List */\n.log-list {\n  list-style: none;\n  padding-left: 25px;\n  margin: 5px 0;\n}\n\n.log-date-group {\n  margin: 10px 0;\n}\n\n.log-date-header {\n  font-weight: 500;\n  color: #495057;\n  padding: 5px 0;\n  background-color: #f8f9fa;\n  padding-left: 10px;\n  border-radius: 4px;\n}\n\n.log-items {\n  list-style: none;\n  padding-left: 15px;\n  margin: 5px 0;\n}\n\n.log-item {\n  padding: 5px 10px;\n  color: #666;\n  font-size: 0.9em;\n  border-left: 2px solid #dee2e6;\n  margin: 5px 0;\n}\n\n.log-item:hover {\n  background-color: #f8f9fa;\n  border-left-color: #6c757d;\n}\n\n/* Expand/Collapse Icons */\nspan {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .logs-container {\n    padding: 10px;\n  }\n  \n  .log-months {\n    padding-left: 10px;\n  }\n  \n  .log-list {\n    padding-left: 15px;\n  }\n  \n  .log-item {\n    font-size: 0.85em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
